import styled from "styled-components";

const Wrapper = styled.footer`
  text-align: center;
`;

const Divider = styled.hr`
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
`;

const VersionInfo = styled.p`
  font-size: 12px;
`;

// index.html carries %REACTBUILDVERSION%, which the build script fills in. It is
// not guaranteed: in dev nothing substitutes it. The release version is gone with
// Heroku but the parsing stays, so an older cached index.html still renders.
// Show whichever parts we have rather than "vNaN | deployed at Invalid Date".
const buildInfo = () => {
  const { createdAt, releaseVersion } = window.appMetadata || {};

  // the build runs before the release is cut, so the next release is this + 1
  const release = parseInt(String(releaseVersion || "").replace(/^v/, ""), 10);
  const version = Number.isNaN(release) ? null : `v${release + 1}`;

  const built = new Date(createdAt);
  const deployedAt = Number.isNaN(built.getTime())
    ? null
    : `deployed at ${built.toLocaleString()}`;

  return [version, deployedAt].filter(Boolean).join(" | ");
};

const Footer = () => {
  const info = buildInfo();
  return (
    <Wrapper>
      <Divider />
      <VersionInfo>{info ? `${info} ₿` : "₿"}</VersionInfo>
    </Wrapper>
  );
};

export default Footer;
